import { Box, Card, Text } from '@mantine/core'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { SignInCardProps } from './SignInCard.types'
import classes from './SignInCard.module.scss'
import { config } from '@percent/workplace-giving/config/config'

export function SignInCard({ title, description, children }: SignInCardProps) {
  const { t } = useTranslation()

  return (
    <Box className={classes.Wrapper}>
      <Card className={classes.Card}>
        <Text component="h2" className={classes.Title}>
          {title}
        </Text>
        {description ? <Text className={classes.Description}>{description}</Text> : null}
        <Box className={classes.ContentWrapper}>{children}</Box>
      </Card>

      <Box className={classes.TermsLinksWrapper}>
        <Link to={config.urls.howItWorksUrl} target="_blank" rel="noopener noreferrer">
          {t('workplace_giving.infoLinks.howItWorks')}
        </Link>
        <span>·</span>
        <Link to={config.urls.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
          {t('workplace_giving.infoLinks.privacyPolicy')}
        </Link>
        <span>·</span>
        <Link to={config.urls.termsOfUseUrl} target="_blank" rel="noopener noreferrer">
          {t('workplace_giving.infoLinks.termsOfUse')}
        </Link>
      </Box>
    </Box>
  )
}
